<template>
  <div class="header__member-child-selector">
    <div @click.prevent="toggleChildMemberSelector">
      <h1 class="member-child-selector__name header__member-name">{{ decode(memberName) }}</h1>
      <div class="member-child-selector__indicator">
        <i class="fa fa-chevron-down"></i>
      </div>
    </div>
    <ul class="member-child-selector__child-list"
      :class="{ 'member-child-selector__child-list--active': isListActive }"
    >
      <ChildOption v-for="(child, index) in children" :member="child" :key="index" @selection="hideList"></ChildOption>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ChildOption from './ChildOption.vue';
  import FuelUtilities from '../../../FuelUtilities';

  export default {
    name: "ChildSelect",
    mixins: [FuelUtilities],
    components: {
      ChildOption,
    },
    data() {
      return {
        isListActive: false,
      };
    },
    computed: {
      ...mapGetters('main', ['memberName', 'children']),
    },
    methods: {
      toggleChildMemberSelector() {
        this.isListActive = !this.isListActive;
      },
      hideList() {
        this.isListActive = false;
      }
    },
  };
</script>

